module.exports = __webpack_public_path__ + "img/manajemen_pelanggan.88f3fa3c.svg";